import {
  Button,
  IconButton,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import React, { FC } from 'react';
import colors from '../../../../../themes/main-colors';
import { Close } from '@material-ui/icons';
import { useTranslation } from '../../../../../hooks/useTranslation';
import useAuth from '../../../../../hooks/useAuth';

type Props = {
  open: boolean;
  onClose: () => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalWrapper: {
      display: 'flex',
      width: '560px',
      maxHeight: '77.21vh',
      flexDirection: 'column',
      position: 'absolute',
      overflow: 'auto',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: theme.spacing(3.5, 3, 2.5, 3),
      backgroundColor: colors.modalBackgroundColor,
      borderRadius: '5px',
      [theme.breakpoints.down('sm')]: {
        top: '50%',
        width: '90%',
        maxHeight: '100%',
        padding: theme.spacing(3),
      },
    },
    closeButton: {
      position: 'absolute',
      top: 6,
      right: 24,
    },
    infoMessageHeader: {
      marginBottom: '2rem',
      marginLeft: '1rem',
    },
    infoMessage: {
      marginBottom: '1rem',
    },
    disconnectedReconnectPopupClose: {
      width: '120px',
      color: colors.sparkBlue,
    },
    buttonContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
    modalBody: {},
    kickerText: {
      paddingBottom: theme.spacing(1.875),
      paddingTop: theme.spacing(1.25),
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
  }),
);

const DisconnectedReconnectInfoPopup: FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <div className={classes.modalWrapper}>
        <div className={classes.closeButton}>
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={onClose}
            data-testid="close-icon"
          >
            <Close />
          </IconButton>
        </div>
        {isAuthenticated && (
          <Typography variant={'h3'} className={classes.infoMessageHeader}>
            {t('DISCONNECT_RECONNECT_POPUP_CONTENT_AUTHENTICATED')}
          </Typography>
        )}
        {!isAuthenticated && (
          <Typography variant={'h3'} className={classes.infoMessageHeader}>
            {t('DISCONNECT_RECONNECT_POPUP_CONTENT_UNAUTHENTICATED')}
          </Typography>
        )}
        <div className={classes.buttonContainer}>
          <Button
            className={classes.disconnectedReconnectPopupClose}
            onClick={onClose}
            style={{
              background: colors.white,
              border: `1.5px solid ${colors.sparkBlue}`,
            }}
          >
            {t('CLOSE')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DisconnectedReconnectInfoPopup;
